/**
 * Sage fields on an order (same shape as legacy GET /sage/sync/status).
 * Prefer order.sage_sync_status / sage_invoice_id from GET /order.
 */
export interface SageSyncStatus {
  sage_sync_status: string;
  sage_invoice_id?: string;
}

/** UI label from order payload (list or detail). */
export function sageSyncLabelFromOrder(
  order: {
    sage_sync_status?: string | null;
    sage_invoice_id?: string | null;
  } | null | undefined
): string {
  if (!order) return '—';
  const raw = order.sage_sync_status;
  if (raw != null && String(raw).trim() !== '') {
    const v = String(raw).toLowerCase();
    if (v === 'synced' || v === 'sync') return 'Synced';
    if (v === 'failed') return 'Failed';
    if (v === 'sent') return 'Sent';
    return String(raw);
  }
  if (order.sage_invoice_id) return 'Synced';
  return '—';
}
